import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { usePlaces } from "../context/PlacesContext";
import { PlaceCard, SectionLabel } from "../components/Bits";

export default function GuideDetail() {
  const { slug } = useParams();
  const { guides, placesFromSlugs, loading } = usePlaces();

  if (loading) {
    return <div className="pt-[140px] pb-40 text-center text-ink-soft font-serif text-2xl">Loading…</div>;
  }

  const guide = (guides || []).find((g) => g.slug === slug);

  if (!guide) {
    return (
      <div className="pt-[140px] pb-40 text-center" data-testid="guide-not-found">
        <h1 className="font-serif text-4xl">Guide not found.</h1>
        <Link to="/guide" className="inline-block mt-6 text-claret link-underline">Back to Guides</Link>
      </div>
    );
  }

  const places = placesFromSlugs(guide.placeSlugs || []);

  return (
    <div className="pt-[68px]" data-testid="guide-detail-page">
      <section className="relative h-[54vh] min-h-[400px] flex items-end overflow-hidden">
        <div className="absolute inset-0 kenburns">
          <img src={guide.cover} alt={guide.title} className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-ink/30" />
        <div className="relative max-w-[1100px] mx-auto px-6 lg:px-10 w-full pb-12">
          <Link to="/guide" className="inline-flex items-center gap-2 text-paper/70 hover:text-paper text-sm mb-6">
            <ArrowLeft className="w-4 h-4" /> All guides
          </Link>
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-8 bg-brass" />
            <span className="eyebrow text-brass">Guide · {places.length} places</span>
          </div>
          <h1 className="font-serif text-paper text-4xl sm:text-5xl md:text-7xl font-semibold leading-[1.02] display-balance max-w-3xl">
            {guide.title}
          </h1>
        </div>
      </section>

      <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-16">
        <p className="font-serif text-2xl md:text-3xl leading-snug max-w-3xl display-balance">{guide.dek}</p>
        <p className="text-sm text-ink-soft mt-6">Curated by {guide.author} · {guide.date}</p>
      </div>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
        <SectionLabel>In this guide</SectionLabel>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14 mt-10">
          {places.map((p, i) => <PlaceCard key={p.id} place={p} index={i} />)}
        </div>
      </section>
    </div>
  );
}
